module.exports = __webpack_public_path__ + "img/icon-zx-customer.13d3194a.png";